import { defineComponent as _defineComponent } from 'vue'
import TooltippedText from '../../tooltip/TooltippedText/TooltippedText.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavSubItem',
  props: {
    name: null,
    active: { type: Boolean },
    minimized: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
(e: "click"): void;
}), expose: any, slots: any, attrs: any }) {






return { __sfc: true,emit, TooltippedText }
}

})